import { ReactEnv } from "@/@types/env";

const getEnv = (key: keyof ReactEnv): string => {
  // Skip in unit tests
  if (import.meta.env.VITEST === "true") {
    return "";
  }

  const value = import.meta.env.VITE_LOCAL
    ? import.meta.env[`VITE_${key}`]
    : typeof window !== "undefined"
      ? window.env?.[key]
      : undefined;

  return value || "";
};

export class EnvVar {
  static auth0Audience = getEnv("AUTH0_AUDIENCE") || "https://mutinex-dev.au.auth0.com/api/v2/";
  static auth0ClientId = getEnv("AUTH0_CLIENT_ID");
  static auth0OrgId: string | undefined = getEnv("AUTH0_ORG_ID");
  static auth0PlatformDomain = getEnv("AUTH0_PLATFORM_DOMAIN") || "dev.au.identity.mutinex.co";
  static backendUrl = getEnv("BACKEND_URL") || window.location.origin;
  static insightsBackendUrl = getEnv("INSIGHTS_BACKEND_URL") || window.location.origin;
  static envName = getEnv("ENV_NAME");
  static local = import.meta.env.VITE_LOCAL;
  static segmentWriteKey = getEnv("SEGMENT_WRITE_KEY");
  static statsigFrontendKey = getEnv("STATSIG_FRONTEND_KEY");
  static sentryDsn = getEnv("SENTRY_DSN");
  static version = getEnv("VERSION");
  static nestBackendUrl = getEnv("NEST_BACKEND_URL");
  static intercomAppId = getEnv("INTERCOM_APP_ID");
  static maiteUrl = getEnv("MAITE_URL") || "http://localhost:8180";
  static sboUrl = getEnv("SBO_URL") || "https://staging.sbo.mutinex.co";
}
